import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import { ButtonIcon } from '@elamajs/ui-kit'

import IndexFormInner from '../IndexFormInner/IndexFormInner'
import { VARIANT_TO_RENDER } from '../../constants'

import edtechImage from '@src/static/img/modals/modal-edtech.png'
import medicineImage from '@src/static/img/modals/modal-medicine.png'
import realtyImage from '@src/static/img/modals/modal-realty.png'
import statisticsImage from '@src/static/img/modals/modal-trends-bg.png'

import * as Styled from './ModalForm.styled'

type Props = {
  isOpen: boolean
  variant: string
  renderPlace: string
  elementId: string
  handleClose: () => void
}

// Захардкоженное значение для данной анимации
const ANIMATION_DURATION = 200

const ModalForm: FC<Props> = ({ isOpen, handleClose, variant, renderPlace, elementId }) => {
  const [isAnimating, setIsAnimating] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)

  const image = useMemo(() => {
    switch (variant) {
      case VARIANT_TO_RENDER.MEDICINE:
        return medicineImage
      case VARIANT_TO_RENDER.REALTY:
        return realtyImage
      case VARIANT_TO_RENDER.STATISTICS:
        return statisticsImage
      default:
        return edtechImage
    }
  }, [variant])

  const title = useMemo(() => {
    switch (variant) {
      case VARIANT_TO_RENDER.MEDICINE:
        return <>Отраслевые исследования: Медицина&nbsp;2026</>
      case VARIANT_TO_RENDER.REALTY:
        return <>Отраслевые исследования: Недвижимость&nbsp;2026</>
      case VARIANT_TO_RENDER.STATISTICS:
        return <>Индекс рекламной активности</>
      default:
        return <>Отраслевые исследования: EdTech&nbsp;2026</>
    }
  }, [variant])

  const handleClickContainer = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
  }, [])

  useEffect(() => {
    if (isOpen) {
      // @Note - Необходимо для корректной работы анимации открытия\закрытия модалки
      setShouldRender(true)
      setIsAnimating(true)
      document.body.style.overflow = 'hidden'
    } else {
      setIsAnimating(false)
      document.body.style.overflow = 'auto'

      const timer = setTimeout(() => {
        setShouldRender(false)
      }, ANIMATION_DURATION)

      return () => clearTimeout(timer)
    }
  }, [isOpen])

  if (!shouldRender) return null

  return createPortal(
    <Styled.Overlay onClick={handleClose} $isOpened={isAnimating}>
      <Styled.ModalContainer $variant={variant} onClick={handleClickContainer}>
        <Styled.ButtonClose
          as={ButtonIcon}
          icon="cross"
          size="m"
          variant="outlined"
          onClick={handleClose}
        />
        <Styled.Wrapper>
          <Styled.BackgroundImage src={image} $variant={variant} />
          <Styled.ModalContent>
            <Styled.ColumnLeft>
              <Styled.ModalTitle $variant={variant}>{title}</Styled.ModalTitle>
            </Styled.ColumnLeft>
            <Styled.ColumnRight>
              <IndexFormInner renderPlace={renderPlace} elementId={elementId} variant={variant} />
            </Styled.ColumnRight>
          </Styled.ModalContent>
        </Styled.Wrapper>
      </Styled.ModalContainer>
    </Styled.Overlay>,
    document.getElementById('modal-portal') || document.body
  )
}

export default ModalForm
